// Filename - components/SubMenu.js
import axios from 'axios';
import React, { useState } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { apis, serverCall } from "../utils/api/constant";

const SidebarLink = styled(Link)`
    display: flex;
    color: #e1e9fc;
    justify-content: space-between;
    align-items: center;
    padding: 20px;
    list-style: none;
    height: 60px;
    text-decoration: none;
    font-size: 15px;
    font-family:"Roboto-Regular";

    &:hover {
        background: #17709B;
        border-left: 4px solid green;
        cursor: pointer;
    }
    &:selection {
        background: #17709B;
      } 
      a:active {
        color: blue;
      }
`;

const SidebarLabel = styled.span`
    margin-left: 16px;
`;

const DropdownLink = styled(Link)`
    background: #687C95;
    height: 60px;
    padding-left: 3rem;
    display: flex;
    align-items: center;
    text-decoration: none;
    color: #f5f5f5;
    font-size: 15px;
    font-family:"Roboto-Regular";

    &:hover {
        background: #17709B;
        cursor: pointer;
    }
`;

const SubMenu = ({ item }) => {
    const [subnav, setSubnav] = useState(false);

    const showSubnav = () => setSubnav(!subnav);
 // Function to handle logout
 const  handleLogout = async () => {
    // Clear localStorage
    const userData =  JSON.parse(localStorage.getItem("USER_DETAILS")); 
    let response = await serverCall(apis.USER_LOGOUT, "POST", { "userName": userData?.pDATASET[0]?.USERNAME, "apiID":0, "param1": 0 ,"param2": 0, "param3": 0, "param4": 0, "param5": "", "param6": ""}, { "sid": userData.token });
    if(response.data.ERROR_STATUS){
        window.location.href = '/';  // Correct syntax for redirecting
    }
  };
    return (
        <>
            <SidebarLink 
                to={item.path}
                onClick={item.title === 'Logout' ? handleLogout : item.subNav && showSubnav} // Check if the item is 'Logout'
            >
                <div>
                    {item.icon}
                    <SidebarLabel>
                        {item.title}
                    </SidebarLabel>
                </div>
                <div>
                    {item.subNav && subnav
                        ? item.iconOpened
                        : item.subNav
                            ? item.iconClosed
                            : null}
                </div>
            </SidebarLink>
            {subnav &&
                item.subNav.map((item, index) => {
                    return (
                        <DropdownLink
                            to={item.path}
                            key={index}
                        >
                            {item.icon}
                            <SidebarLabel>
                                {item.title}
                            </SidebarLabel>
                        </DropdownLink>
                    );
                })}
        </>
    );
};

export default SubMenu;
